export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-target-two-5917a04412280201121526353427e945.svg";